import React from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";

import VimeoVideo from "@app/component/VimeoVideo";

import InfoLinks from "../InfoLinks";

import styles from "./GetStarted.module.scss";

interface Props {}

const GetStartedSection: React.FC<Props> = () => {
  return (
    <div>
      <Row className={styles.panelRow}>
        <Col sm={{ span: 24 }} xl={{ span: 8 }}>
          <InfoLinks />
        </Col>
        <Col sm={{ span: 24 }} xl={{ span: 16 }}>
          <VimeoVideo className={styles.video} videoId="523646702" />
        </Col>
      </Row>
    </div>
  );
};

export default GetStartedSection;
